module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/wipes_503a2d.png";